// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.cardstack",
    name: "Card Wallet",
    homepage: "https://cardstack.com/earn-together",
    image_id: "325428cf-c212-4d83-a434-7f48902d2c00",
    app: {
        browser: null,
        ios: "https://cardstack.com/ios",
        android: "https://cardstack.com/android",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "cardwallet://",
        universal: "https://wallet.cardstack.com",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map